import api from "@/lib/api";
import { ADMIN_PROFILES, TMA_PROFILES } from "@/constants/constants";

const getMe = async () => {
  try {
    const response = await api.get("/user/me");
    const userData = response.data;
    if (![...ADMIN_PROFILES, ...TMA_PROFILES].includes(userData.profile)) {
      throw new Error("Unauthorized profile");
    }
    return userData;
  } catch (error) {
    throw new Error(
      error instanceof Error ? error.message : "Error fetching user data",
    );
  }
};

export { getMe };
